import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor, IconName, IconSize } from '@freelancer/ui/icon';

@Component({
  standalone: false,
  selector: 'app-project-location-details',
  template: `
    <div class="Location Location-container">
      <div>
        <div class="Location-item">
          <fl-icon
            class="mr-xxsmall"
            flTrackingLabel="FirstLocationIcon"
            [color]="displayLocationIconColor"
            [name]="displayLocationIcon"
            [size]="IconSize.SMALL"
            [useIconFont]="true"
            [fillIconFont]="true"
          ></fl-icon>
          <div class="Location-address">
            <p>{{ displayLocation }}</p>
          </div>
        </div>
        @if (displayEndLocation) {
          <div class="Location-item">
            <fl-icon
              class="mr-xxsmall"
              flTrackingLabel="SecondLocationIcon"
              [color]="IconColor.ERROR"
              [name]="'ui-pin-location'"
              [size]="IconSize.SMALL"
              [useIconFont]="true"
              [fillIconFont]="true"
            ></fl-icon>
            <div class="Location-address">
              <p>{{ displayEndLocation }}</p>
            </div>
          </div>
        }
      </div>
      @if (displayGoogleMapsLink) {
        <fl-link
          flTrackingLabel="MapsLinkClick"
          flTrackingSection="ProjectLocation"
          [flTrackingReferenceType]="projectId ? 'project_id' : undefined"
          [flTrackingReferenceId]="projectId"
          [link]="mapLocationLink"
        >
          <fl-icon
            class="Location-link-icon mr-xxsmall"
            name="ui-open-external"
            [color]="displayLocationIconColor"
            [size]="IconSize.SMALL"
            [useIconFont]="true"
            [fillIconFont]="true"
          ></fl-icon>
        </fl-link>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./project-location-details.component.scss'],
})
export class ProjectLocationDetailsComponent implements OnInit {
  IconColor = IconColor;
  IconSize = IconSize;

  @Input() displayLocation: string;
  @Input() displayLocationIcon: IconName = 'ui-pin-location';
  @Input() displayLocationIconColor = IconColor.SECONDARY;
  @Input() displayEndLocation?: string;
  @Input() displayGoogleMapsLink = false;
  @Input() projectId?: number;

  mapLocationLink: string;

  ngOnInit(): void {
    this.mapLocationLink = this.getGoogleMapsLink();
  }

  getGoogleMapsLink(): string {
    const googleMapsUrl = 'https://www.google.com/maps';
    const encodedOrigin = encodeURIComponent(this.displayLocation);
    let path = `/search/?api=1&query=${encodedOrigin}`;
    if (this.displayEndLocation) {
      const encodedDestination = encodeURIComponent(this.displayEndLocation);
      path = `/dir/?api=1&origin=${encodedOrigin}&destination=${encodedDestination}`;
    }
    return `${googleMapsUrl}${path}`;
  }
}
